export default __webpack_public_path__ + "16d3d172710579fca4baa994fa8904a0.png";